<template>
    <div class="row">
        <div class="home-page">
            <div class="content">
                <div>
                    <!-- Alerts -->
                    <div class="card sidebar-section-card alerts-card">
                        <h4 class="section-title"><i class="fa fa-bell"></i> Alerts</h4>
                        <ul class="alert-list">
                            <!-- New Updates -->
                            <li class="alert-item">
                                <div class="alert-content" v-if="newUpdateAlerts.length === 0">
                                    <span class="alert-tag non-recent-alert">New Updates</span>
                                    <span class="alert-message">There are no new updates.</span>
                                </div>
                                <div class="alert-content" v-else>
                                    <span class="alert-tag new-enhancements">New Updates</span>
                                    <ul class="alert-list">
                                        <li v-for="(alert, index) in newUpdateAlerts" :key="index" class="alert-list">
                                            {{ alert.message }}
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <!-- Upcoming Changes -->
                            <li class="alert-item">
                                <div class="alert-content" v-if="upcomingChangesAlerts.length === 0">
                                    <span class="alert-tag non-recent-alert">Upcoming Changes</span>
                                    <span class="alert-message">There are no upcoming changes.</span>
                                </div>
                                <div class="alert-content" v-else>
                                    <span class="alert-tag upcoming-changes">Upcoming Changes</span>
                                    <ul class="alert-list">
                                        <li v-for="(alert, index) in upcomingChangesAlerts" :key="index" class="alert-list">
                                            {{ alert.message }}
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <!-- Developments -->
                            <li class="alert-item">
                                <div class="alert-content" v-if="developmentsAlerts.length === 0">
                                    <span class="alert-tag developments non-recent-alert">Developments</span>
                                    <span class="alert-message">There are no current developments.</span>
                                </div>
                                <div class="alert-content" v-else>
                                    <span class="alert-tag developments global-development">Developments</span>
                                    <ul class="alert-list">
                                        <li v-for="(alert, index) in developmentsAlerts" :key="index" class="alert-list">
                                            {{ alert.message }}
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <!-- System Maintenance -->
                            <li class="alert-item">
                                <div class="alert-content" v-if="systemMaintenanceAlerts.length === 0">
                                    <span class="alert-tag non-recent-alert">System Maintenance</span>
                                    <span class="alert-message">There is no system maintenance planned.</span>
                                </div>
                                <div class="alert-content" v-else>
                                    <span class="alert-tag system-maintenance">System Maintenance</span>
                                    <ul class="alert-list">
                                        <li v-for="(alert, index) in systemMaintenanceAlerts" :key="index" class="alert-list">
                                            {{ alert.message }}
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="welcome-section">
                        <div class="main-card-content card">

                            <!-- News Section -->
                            <div class="news-section">
                                <h4 class="section-title"><i class="fa fa-solid fa-folder-open"></i> Latest News</h4>
                                <div v-for="(newsItem, index) in currentNewsPage" :key="index" class="news-item"
                                    @click="navigateToNewsPage(newsItem)">
                                    <img :src="newsItem.image" :alt="`${newsItem.title} Image`" class="news-image">
                                    <div class="news-text">
                                        <h4 class="news-title">{{ newsItem.title }}</h4>
                                        <p class="news-description">{{ newsItem.description }}</p>
                                        <p class="news-datetime">{{ formatDateTime(newsItem.dateTime) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="pagination-footer">
                                <p-pagination class="pull-right" v-model="currentPage" :per-page="itemsPerPage"
                                    :total="latestNews.length"></p-pagination>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <!-- Verifications Area -->
                    <div class="card sidebar-section-card" v-if="!(paymentType === 'NONE')">
                        <h4 class="section-title"><i class="fa fa-hourglass"></i> Verifications</h4>
                        <div style="display: flex; flex-direction: column; justify-content: space-between; height: 70%">
                            <ul class="verification-list">
                                <li class="verification-item" v-for="(verification, index) in verificationsArray" :key="index">
                                    <span class="verification-span">{{ verification.label }}:<strong> {{ verification.count }}</strong></span>
                                    <button class="btn btn-sm btn-fill"
                                        @click="navigateToVerification(verification)">View</button>
                                </li>
                            </ul>
                            <div style="margin: auto;">
                                <button class="btn btn-fill btn-md" @click="navigateToNewVerification()"> <i
                                        class="fa fa-plus"></i>Add New Verification</button>
                            </div>

                        </div>
                    </div>
                    
                    <div class="siderbar-section">
                        <!-- Usage Chart -->
                        <div class="card sidebar-section-card usage-card" v-if="!(paymentType === 'NONE')">
                            <h4 class="section-title"><i class="fa fa-line-chart" style="height: 30px; width: 30px"></i>
                                Volume
                            </h4>
                            <usage-graph></usage-graph>
                        </div>
                        <!-- Resources Section -->
                        <!-- <div class="card sidebar-section-card" v-if="this.videoLink != ''">
                            <h4 class="section-title"><i class="fa fa-lg fa-info-circle"
                                    style="margin-right: 10px"></i>Resources
                            </h4>
                            <span>Our Resources hub is coming soon, your one-stop destination for valuable how-to guides, videos, product insights, and presentations. To tell us what resources you'd like to see here by emailing <a href="mailto:customersuccess@qualificationcheck.com">customersuccess@qualificationcheck.com</a>.</span>
                            
                            <span>Looking for additional resources? Explore our <a
                                    href="https://www.qualificationcheck.com/resources/" target="_blank">Resources</a> for
                                more information or take a look at our latest update video below.</span>
                            <iframe style="margin-top: 5px" width="100%" height="315" :src="videoLink" frameborder="0"
                                allowfullscreen></iframe>
                        </div> -->
                        <!-- FAQs Section -->
                        <div class="card sidebar-section-card">
                            <h4 class="section-title"><i class="fa fa-lg fa-question-circle" style="margin-right: 5px"></i>
                                FAQs</h4>
                            <span>Can't see what you're looking for? Check out our <a
                                    href="https://qualificationcheck.com/organisation-faqs/" target="_blank">FAQs</a> for more
                                information.</span>
                        </div>
                        <!-- Contact an Account Manager/Customer Care -->
                        <div class="card sidebar-section-card">
                            <h4 class="section-title"><i class="fa fa-user"></i> We'd love your feedback</h4>
                            <span>We value your experience with Qualification Check, and would love to receive your feedback with us to help us improve. Click <a
                                    href="https://docs.google.com/forms/d/e/1FAIpQLSfgL8fNFlQtIA4y68P3ZHHyBdi8cfZG6U_eP2A_o5Pr9Gvmew/viewform?usp=sf_link" target="_blank">here</a> to share with us now</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import PPagination from 'src/components/Pagination.vue'
import UsageGraph from './components/UsageGraph.vue';
import moment from 'moment';

export default {
    components: {
        PPagination,
        UsageGraph,
    },
    data() {
        return {
            usageChartData: {
                labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                datasets: [
                    {
                        label: 'Usage Data',
                        backgroundColor: '#3CA5A9',
                        borderColor: '#3CA5A9',
                        data: [50, 75, 30, 10, 20, 85, 80, 25, 15, 30],
                    },
                ],
            },
            usageChartOptions: {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ],
                },
            },
            userName: this.$store.state.username,
            latestNews: [


            ],
            newUpdateAlerts: [],
            upcomingChangesAlerts: [],
            developmentsAlerts: [],
            systemMaintenanceAlerts: [],
            verificationsArray: [
                {
                    label: "Verifications in Progress",
                    count: this.$store.state.verificationsInProgress,
                    tag: "in-progress",
                    labelClass: "in-progress-label",
                    countClass: "in-progress-count",
                    title: "Verifications in Progress",
                    status: "Pending"
                },
                {
                    label: "Verifications with Action Required",
                    count: this.$store.state.verificationsActionRequired,
                    tag: "action-required",
                    labelClass: "action-required-label",
                    countClass: "action-required-count",
                    title: "Verifications with Action Required",
                    status: "Action Required"
                },
                /*
                {
                    label: "Incomplete Verifications",
                    count: this.$store.state.verificationsIncomplete,
                    tag: "incomplete",
                    labelClass: "incomplete-label",
                    countClass: "incomplete-count",
                    title: "Incomplete Verifications",
                    status: "Incomplete"
                }
                */
            ],
            itemsPerPage: 9,
            currentPage: 1,
            videoLink: "",
            paymentType: this.$store.state.paymentType,            
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.latestNews.length / this.itemsPerPage);
        },
        currentNewsPage() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.latestNews.slice(startIndex, endIndex);
        },
    },
    methods: {
        navigateToNewsPage(newsItem) {
            window.open(newsItem.url, '_blank');
        },
        async navigateToVerification(verification) {
            let result = '';
            if (verification.status === 'Pending') {
                result = 'PENDING';
            } else if (verification.status === 'Incomplete') {
                result = 'INCOMPLETE';
            } else if (verification.status === 'Action Required') {
                result = 'ACTION';
            }
            this.$router.push({ path: 'verification/history', query: { result } });
        },
        navigateToNewVerification() {
            this.$router.push({ name: 'New Verification' });
        },
        formatDateTime(dateTimeStr) {
            return moment(dateTimeStr).format('Do MMMM YYYY');
        },
        goToPage(pageNumber) {
            if (pageNumber >= 1 && pageNumber <= this.totalPages) {
                this.currentPage = pageNumber;
            }
        },
    },
    mounted() { 
        if(!this.$store.state.isIndividual) {
            var value = 0
            this.$api.getVerificationMetaData(["PENDING"])
            .then(response => {              
                if(response.data.resultCounts.length) {
                    response.data.resultCounts.forEach(result => {
                        value = value + result.value
                    })
                }
                this.verificationsArray[0].count = value
            }) 
        }

        this.$api.getAlertsData()
            .then(response => {
                for (const item of response.content) {
                    if (item.title === "VIDEO") {
                        this.videoLink = item.url;
                    } else if (item.type === "NEWS" && item.active) {
                        this.latestNews.push({
                            title: item.title,
                            image: item.image, 
                            description: item.description,
                            url: item.url,
                            dateTime: item.dateTime,
                        });
                    } else if (item.type === "ALERT_MAINTENANCE" && item.active) {
                        if (item.title === "New Updates") {
                            this.newUpdateAlerts.push({ message: item.description });
                        } else if (item.title === "Upcoming Changes") {
                            this.upcomingChangesAlerts.push({ message: item.description });
                        } else if (item.title === "Developments") {
                            this.developmentsAlerts.push({ message: item.description });
                        } else if (item.title === "System Maintenance") {
                            this.systemMaintenanceAlerts.push({ message: item.description });
                        }
                    }
                }
                this.latestNews.sort((a, b) => {
                    if (a.dateTime > b.dateTime) {
                        return -1;
                    } else if (a.dateTime < b.dateTime) {
                        return 1;
                    }
                    // a must be equal to b
                    return 0;
                    });
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });                
    },
};
</script>

  
<style scoped>
h4 {
    margin-top: 10px;
}

.content {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 20px;
}

.main-card-content,
.sidebar-section-card {
    padding: 15px;
}

.card {
    background-color: white;
    border-radius: 8px;
}

.section-title {
    color: #3CA5A9;
}

.news-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 8px;
    border-bottom: 1px solid #ddd;
    transition: background-color 0.3s ease-in-out;
}

.news-item:hover {
    background-color: #f5f5f5;
}

.news-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    margin-right: 10px;
    border-radius: 4px;
}

.news-text {
    flex: 1;
}

.news-title {
    color: #28465A;
    margin: 0;
}

.news-datetime {
    font-size: small;
}

.news-description {
    margin: 5px 0;
}

.faq-list,
.verification-list {
    list-style-type: none;
    margin-left: -40px;
    margin-bottom: 0px;
}

.faq-item,
.verification-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;

}

.faq-item a {
    color: #007BFF;
    text-decoration: none;
}

.contact-text {
    margin: 10px 0;
    color: #555;
}

.alert-list {
    list-style-type: none;
    padding-left: 0;
}

.alert-item {
    margin-bottom: 10px;
}

.alert-content {
    display: flex;
    align-items: center;
}

.alert-tag {
    font-weight: bold;
    border-radius: 4px;
    padding: 2px 6px;
    margin-right: 8px;
    margin-top: 2px;
    text-align: center;
    width: 100%;
    max-width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;

}

.alert-message {
    flex: 1;
    width: 80%;
}

.system-maintenance {
    background-color: #DC3545;
    color: white;
}

.global-development {
    background-color: #007BFF;
    color: white;
}

.upcoming-changes {
    background-color: #FFC107;
    color: black;
}

.new-enhancements {
    background-color: green;
    color: white;
}


.non-recent-alert {
    background-color: #555;
    color: #ccc;
}

.main-card-content {
    padding-bottom: 0;
}

.pagination-footer {
    margin-top: auto;
    padding: 20px 10px;
    display: flex;
    justify-content: flex-end;
}

.verification-span {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-right: 10px;
    align-items: center;
}

@media (max-width: 1200px) {
    .content {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 0px;
    }

    .siderbar-section {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 0px;
    }
}

@media (max-width: 992px) {
    .content {
        padding-left: 10px;
        padding-right: 10px;
    }
}

@media (max-width: 568px) {
    .alert-content {
        display: inline;
        width: 100%;
        max-width: 100%;
    }

    .alert-tag {
        margin-bottom: 5px;
        margin: auto;
        width: 100%;
        max-width: 100%;
    }
}
</style>


